module.exports = __webpack_public_path__ + "img/lines-1.2aea9b15.png";